// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import reviewEntity from './entities/review.json';
import reviewMenu from '../pages/review/menu.json';
import reviewFullForm from '../pages/review/forms/full.json';
import reviewContextForm from '../pages/review/forms/context.json';
import reviewMiniForm from '../pages/review/forms/mini.json';
import reviewLookupForm from '../pages/review/forms/lookup.json';
import reviewTableView from '../pages/review/views/table.json';
import reviewCardsView from '../pages/review/views/cards.json';
import reviewDashboardView from '../pages/review/views/dashboard.json';

/** Тип запису «Перевірка» зі сторінками пакета: меню, форми та подання з pages/review/. */
export const reviewDefinition: IRecordTypeDefinition = {
  ...reviewEntity,
  views: assembleViewSet({
      table: reviewTableView,
      cards: reviewCardsView,
      dashboard: reviewDashboardView,
  }),
  form: reviewFullForm,
  forms: { full: reviewFullForm, context: reviewContextForm, mini: reviewMiniForm, lookup: reviewLookupForm },
  menu: reviewMenu,
} as IRecordTypeDefinition;
